import 'twin.macro';
import React from 'react';
import { SubHeader } from '@teetsh/app/src/components/SubHeader';
import ButtonLink from '@teetsh/app/src/components/Buttons/Link';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { Trans, useTranslation } from 'react-i18next';

interface Props {
  remainingDays: number;
  isPastDue: boolean;
  plan: string;
}

export function SubHeaderExpiringAbo(props: Props) {
  const { remainingDays, isPastDue, plan } = props;
  const { t } = useTranslation(['userSettings']);
  if (!isPastDue) {
    return null;
  }
  return (
    <SubHeader tw="bg-warning-quiet px-6 pt-4">
      <div tw="flex items-center justify-between gap-x-6 gap-y-4 flex-wrap md:flex-nowrap">
        <div tw="flex items-start gap-x-2.5 text-warning-intense">
          <ExclamationTriangleIcon tw="h-5 w-5 mt-0.5 shrink-0" />
          <div>
            <div tw="font-bold">
              {t('userSettings:subscription.subscriptionWillExpireTitle')}
            </div>
            <div>
              <Trans
                i18nKey="userSettings:subscription.subscriptionWillExpireBody"
                values={{ count: remainingDays, plan }}
              >
                __A__<strong>__B__</strong>__C__
              </Trans>
            </div>
          </div>
        </div>
        <div tw="shrink-0 ml-auto">
          <ButtonLink
            to="/settings/subscription?open-card=true"
            intent="warning"
          >
            {t('userSettings:subscription.update')}
          </ButtonLink>
        </div>
      </div>
    </SubHeader>
  );
}
